<div  *ngIf="showModal">
    <div class="modal-header">
        <h5 class="mb-0">{{title | translate }} {{ (item?.id ? 'common.edit' : 'common.create') | translate }}</h5>
    </div>
    <div class="modal-body">
        <form class="k-form k-form-md" [formGroup]="form">
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="name" class="col-form-label">{{ 'common.name' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="text" id="name" formControlName="name" class="form-control" />
                    <app-field-error-message controlName="name"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="shortCode" class="col-form-label">{{ 'common.short_code' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="text" id="shortCode" formControlName="shortCode" class="form-control" />
                    <app-field-error-message controlName="shortCode"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="code" class="col-form-label">{{ 'common.code' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="text" id="code" formControlName="code" class="form-control" />
                    <app-field-error-message controlName="code"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-4 col-xl-4">
                    <app-label controlName="isDefault" class="col-form-label">{{ "common.is_default" | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <input type="checkbox" id="isDefault" formControlName="isDefault" class="form-check-input" />
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label class="col-form-label">{{ 'common.image' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-6 col-xl-6 ">
                    <input type="file" id="image-file-input" (change)="onFileSelected($event)" (cancel)="onFileCancelled()" class="form-control" accept=".png" />
                </div>
                <div class="col-12 col-md-2 col-xl-2">
                    <img class="app-image-fix-width-30px" id="selected-image">
                </div>
                <div class="col-12 col-md-2 col-xl-2">
                    <button class="btn btn-secondary" (click)="onClearImage()">{{ 'common.clear' | translate }}</button>
                </div>
            </div>
    
            <hr>
            <div class="mb-1 row">
                <div class="d-flex justify-content-center mb-1 row w-100">
                    <div class="col-12 col-md-2 col-xl-2">
                        <button type="submit" [appClickWait]="onSave" class="btn btn-primary w-100" themeColor="primary">
                            {{ 'common.save' | translate}}
                        </button>
                    </div>
                    <div *ngIf="item" class="col-12 col-md-2 col-xl-3">
                        <button type="submit" [appClickWait]="onDeleteConfirm" class="btn btn-secondary w-100" themeColor="primary">
                            {{ 'common.delete_item' | translate}}
                        </button>
                    </div>
                    <div class="col-12 col-md-2 col-xl-2">
                        <button class="btn btn-secondary w-100" (click)="onClose()">
                            {{ 'common.cancel' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>    
</div>